module.exports = __webpack_public_path__ + "static/media/bobTail.0af6118f.svg";